import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/api";
import { STORE } from "@/store";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.csrf) localStorage.setItem("csrf_token", data.csrf);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1A1A1A] text-[#F5F2EC] flex items-center justify-center px-5">
      <form onSubmit={submit} data-testid="login-form" className="w-full max-w-md border border-[#F5F2EC]/20 p-8 sm:p-10">
        <div className="w-12 h-12 bg-primary flex items-center justify-center mb-6"><Lock size={22} /></div>
        <h1 className="font-head font-extrabold text-3xl tracking-tight">{STORE.name_en}</h1>
        <p className="text-[#F5F2EC]/60 mt-1 mb-8 text-sm uppercase tracking-widest">Admin Panel</p>
        <label className="block text-xs uppercase tracking-widest mb-2 text-[#F5F2EC]/70">Email</label>
        <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
               className="w-full bg-transparent border border-[#F5F2EC]/25 px-4 py-3 mb-5 focus:border-accent outline-none" required />
        <label className="block text-xs uppercase tracking-widest mb-2 text-[#F5F2EC]/70">Password</label>
        <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
               className="w-full bg-transparent border border-[#F5F2EC]/25 px-4 py-3 mb-7 focus:border-accent outline-none" required />
        <button type="submit" disabled={busy} data-testid="login-submit"
                className="w-full bg-primary text-primary-foreground py-4 font-bold uppercase tracking-wider hover:bg-accent hover:text-foreground transition-colors disabled:opacity-60">
          {busy ? "..." : "Sign in"}
        </button>
        <a href="/" className="block text-center mt-5 text-sm text-[#F5F2EC]/50 hover:text-[#F5F2EC] link-underline w-fit mx-auto">← Back to site</a>
      </form>
    </div>
  );
}
